import { DELETE_ARBEITSBEREICH_STATION } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useDeleteArbeitsbereichStation/mutation';
import {
  Mitarbeiter_DeleteArbeitsbereichStationMutation,
  Mitarbeiter_DeleteArbeitsbereichStationMutationVariables,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

export function useDeleteArbeitsbereichStation() {
  const [execute, result] = useMutation<
    Mitarbeiter_DeleteArbeitsbereichStationMutation,
    Mitarbeiter_DeleteArbeitsbereichStationMutationVariables
  >(DELETE_ARBEITSBEREICH_STATION, {
    refetchQueries: ['mitarbeiter_rotationsplanById'],
    awaitRefetchQueries: true,
  });

  const deleteStation = useCallback(
    (variables: Mitarbeiter_DeleteArbeitsbereichStationMutationVariables) => {
      return execute({ variables });
    },
    [execute],
  );

  return [deleteStation, result] as const;
}
